<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Outsourced Sales Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="4">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="4">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6" xs="6" md="4">
              <v-btn class="float-right" :loading="loader" @click="getReport" color="primary"><v-icon
                  left>mdi-list-box-outline</v-icon>Generate Report</v-btn>
            </v-col>
          </v-row>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field label="Search" v-model="search"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8">
              <span class="totals">Total Outsourced Sales: {{ totalSales | currency }}</span>
            </v-col>

            <v-col cols="4">
              <download-excel :data="sales" :fields="fields" name="Outsourced Sales Report">
                Export Excel<v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>

            </v-col>


            <!-- <v-col cols="12" xs="12" md="4">
          <span class="totals" v-if="TotalProfit" v-show="role == 3 || role == 2">Total Profit: {{TotalProfit.toLocaleString()}}</span>
              </v-col>-->

            <v-col cols="12">
              <v-data-table :items-per-page="2000" :mobile-breakpoint="zeroValue" :headers="headers" :items="sales"
                :search="search">
                <template v-slot:item.Price="{ item }">
                  <span v-if="item.Price">{{
                    item.Price | currency
                  }}</span>
                </template>

                <template v-slot:item.LineTotal="{ item }">
                  <span v-if="item.LineTotal">{{
                    item.LineTotal | currency
                  }}</span>
                </template>

                <template v-slot:item.Date="{ item }">
                  <span style="min-width: 80px; display: inline-block">{{
                    item.Date | date
                  }}</span>
                </template>
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      pageItems: 500,
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      sales: [],
      totalSales: 0,
      headers: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Price", value: "Price" },
        { text: "Total Sales", value: "LineTotal" },
        { text: "Date", value: "Date" },
      ],
      fields: {
        Product: "Name",
        Quantity: "Quantity",
        BuyingPrice: "BuyingPrice",
        Price: "Price",
        Total: "LineTotal",
        Date: "Date",
      },
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      const data = this.record;
      data.combinedReport = "N";
      const url = "/daily-outsourced-sales-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.sales = res.ResponseData.sales;
            self.totalSales = res.ResponseData.total;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {

  },
};
</script>

<style lang="scss" scoped></style>